import { withLoyaltyStore } from "../../utils/withLoyaltyStore";

import { PointsHistory as PointsHistoryBase } from "./PointsHistory";

export type * from "./PointsHistory";
export const PointsHistory = withLoyaltyStore(PointsHistoryBase, "PointsHistory");
